import { render, staticRenderFns } from "./BlogBannerSettings.vue?vue&type=template&id=54dc6474&scoped=true"
import script from "./BlogBannerSettings.vue?vue&type=script&lang=js"
export * from "./BlogBannerSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc6474",
  null
  
)

export default component.exports